export const baseMenu = [
  { icon: "mdi-home", text: "main", link: "/" },
  { icon: "mdi-account-clock", text: "Scheduler", link: "Scheduler" },
  { icon: "mdi-pill", text: "need", link: "Order", },
];

export const chatMenu = {
  id: "chat",
  icon: "mdi-chat",
  text: "farmChat",
  link: "Chat",
  badge: 0 // будем брать из Vuex
};

export const ordersMenu = {
  icon: "mdi-chevron-up",
  "icon-alt": "mdi-chevron-down",
  text: "orders",
  model: false,
  children: [
    { icon: "mdi-archive-arrow-down-outline", text: "archive", link: "ArchivePharmacy" },
    { icon: "mdi-archive-arrow-down-outline", text: "adminarchive", link: "AdminArchive" },
    { icon: "mdi mdi-archive-cancel-outline", text: "deletedordersarchive", link: "DeletedOrdersArchivePharmacy" },
    // Виден только тем, у кого в комплекте есть модуль OrdersGeneralArchive
    { icon: "mdi-archive-search-outline", text: "generalordersarchive", link: "GeneralOrdersArchivePharmacy", access: { module: "OrdersGeneralArchive" } },
  ]
};

// Пункт «Блокировка заказов» — для ролей Manager и Programmer (подключается в menuConfig)
export const blockedOrdersMenuItem = { icon: "mdi-lock-outline", text: "blockedOrders", link: "BlockedOrders" };

export const directoryMenu = {
  icon: "mdi-chevron-up",
  "icon-alt": "mdi-chevron-down",
  text: "directory",
  model: false,
  children: [
    { icon: "mdi-city-variant", text: "cities", link: "City" },
    { icon: "mdi-truck-delivery", text: "suppliers", link: "Distributor" },
    { icon: "mdi-hospital-box", text: "goods", link: "Goods" },
    { icon: "mdi-book-open", text: "annotation", link: "Annotation" },
    { icon: "mdi-note-multiple", text: "pricesMenu", link: "Price" },
    { icon: "mdi-account-group", text: "users", link: "User"}
  ]
};

export const controlMenu = {
  icon: "mdi-chevron-up",
  "icon-alt": "mdi-chevron-down",
  text: "control",
  model: false,
  children: [
    { icon: "mdi-account-supervisor-circle", text: "users", link: "UserControl" },
    { icon: "mdi-office-building", text: "companies", link: "CompanyControl" },
    { icon: "mdi-shield", text: "access", link: "AccessControl" },
    { icon: "mdi-shield-edit", text: "accessTemplate", link: "AccessTemplateControl" },
    { icon: "mdi-picture-in-picture-top-right", text: "advertising", link: "AdControl" },
    { icon: "mdi-script-text", text: "orders", link: "OrderControl" },
    { icon: "mdi-file-percent", text: "discountsAndContracts", link: "ContractControl" },
    { icon: "mdi-file-table", text: "shippingAddresses", link: "ShippingAddressControl" },
    { icon: "mdi-credit-card-settings", text: "halykCards", link: "HalykCardsControl" },
    { icon: "mdi-file-document-edit", text: "pricesMenu", link: "PriceControl" },
    { icon: "mdi-truck-delivery", text: "suppliers", link: "DistributorControl" },
    { icon: "mdi-console", text: "Hangfire", link: "Hangfire" },
    { icon: "mdi-book-information-variant", text: "apirequest", link: "apirequestcontrol" },
    { icon: "mdi-newspaper-variant-outline", text: "news", link: "Article" },
    { icon: "mdi-shield-account", text: "UserAccess", link: "UserAccessControl" },
    { icon: "mdi-currency-usd", text: "distributorminsum", link: "DistributorMinSum" },
    { icon: "mdi-trophy", text: "topSales", link: "TopSales" }
  ]
};

export const settingsMenu = {
  icon: "mdi-chevron-up",
  "icon-alt": "mdi-chevron-down",
  text: "setting",
  model: false,
  children: [
    { icon: "mdi-album", text: "priorities", link: "FilialLine", },
    { icon: "mdi-cog", text: "generalSettings", link: "UserSettings", },
    { icon: "mdi-sale", text: "discounts", link: "Discount" }
  ],
};

export const helpMenu = {
  icon: "mdi-help-circle-outline",
  text: "help",
  href: "http://135.181.74.52:3000/"
};

export const reportsMenu = {
  icon: "mdi-chevron-up",
  "icon-alt": "mdi-chevron-down",
  text: "reports",
  model: false,
  children: [
    { icon: "mdi-chart-bar", text: "priceMonitoring", link: "PriceAnalysisReport", },
    { icon: "mdi-chart-bar", text: "averagePriceReport", link: "AveragePriceShareSalesReport", },
    { icon: "mdi-clock-check-outline", text: "priceActuality", link: "FilialPriceActualityReport", },
    { icon: "mdi-trophy", text: "topProductsSold", link: "TopProductsSoldReport", },
    // Виден только тем, у кого в комплекте есть модуль RatingReport
    { icon: "mdi-podium", text: "ratingReport", link: "RatingReport", access: { module: "RatingReport" }, },
    // Виден только тем, у кого в комплекте есть модуль SalesTrendReport
    { icon: "mdi-chart-line", text: "salesTrendReport", link: "SalesTrendReport", access: { module: "SalesTrendReport" }, },
    // Виден только тем, у кого в комплекте есть модуль SalesPerDayReport
    { icon: "mdi-calendar-check", text: "salesPerDayReport", link: "SalesPerDayReport", access: { module: "SalesPerDayReport" }, },
  ],
}

// Вкладка «Аналитика» для менеджеров PharmIT (роли Manager и Programmer, подключается в menuConfig).
// Доступ к страницам проверяется бэкендом по роли, без модулей в комплектах (решение заказчика 21.10.2026).
export const analyticsMenu = {
  icon: "mdi-chevron-up",
  "icon-alt": "mdi-chevron-down",
  text: "analytics",
  model: false,
  children: [
    { icon: "mdi-account-group-outline", text: "clientsComplects", link: "ClientsComplects" },
    { icon: "mdi-file-document-multiple-outline", text: "companyAgreementsReport", link: "CompanyAgreementsReport" },
    { icon: "mdi-view-dashboard-outline", text: "generalIndicators", link: "PurchaseGeneral" },
    { icon: "mdi-cart-outline", text: "pharmacyPurchases", link: "PurchasePharmacies" },
    { icon: "mdi-truck-delivery-outline", text: "distributorsReport", link: "PurchaseDistributors" },
    { icon: "mdi-file-chart-outline", text: "reportActivity", link: "ReportActivity" },
    { icon: "mdi-monitor-eye", text: "pageViewReport", link: "PageViewReport" },
  ],
}

// Утилита для клонирования и удаления элементов по text
export function cloneMenu(menu, exclude = []) {
  return {
    ...menu,
    children: menu.children.filter(c => !exclude.includes(c.text))
  }
}